import slugify from "slugify";
import { ChakraLink as Link, ChakraHeading } from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import { capitalizedHeading } from "./Heading.styles";
import type { HeadingProps } from "./Heading.d";

const Heading = (props: SbEditableComponentProps<HeadingProps>) => {
  const { text, variant, sbEditable } = props;

  const linkId = slugify(text, { lower: true, strict: true });

  const isCapitalizedHeading = variant === "capitals";

  const headingProps = isCapitalizedHeading ? { ...props, ...capitalizedHeading } : { ...props };
  delete headingProps.sbEditable;

  return (
    <>
      <Link id={linkId} display="block" visibility="hidden" pos="relative" top={-24} />
      <ChakraHeading {...headingProps} {...sbEditable}>
        {text}
      </ChakraHeading>
    </>
  );
};

export default Heading;
